module.exports = __webpack_public_path__ + "AnandDhavle-ba4c0a51.webp";